"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hasApplicationCalendar = exports.getCronofyElementTokenOrigin = exports.getCronofyAuthRedirectUri = exports.IconForCalendarProvider = exports.CRONOFY_MAX_DATE_RANGE_LENGTH = exports.CRONOFY_DEFAULT_UNAVAILABLE_PERIOD_ID_PREFIX = exports.CRONOFY_DEFAULT_AVAILABLE_PERIOD_ID_PREFIX = exports.CRONOFY_DEFAULT_AVAILABILITY_RULE_ID = void 0;
var _iconApple = _interopRequireDefault(require("../images/calendar/icon-apple.svg"));
var _iconGoogle = _interopRequireDefault(require("../images/calendar/icon-google.svg"));
var _iconExchange = _interopRequireDefault(require("../images/calendar/icon-exchange.svg"));
var _iconOutlook = _interopRequireDefault(require("../images/calendar/icon-outlook.svg"));
var _monument_symbol = _interopRequireDefault(require("../images/monument_symbol.svg"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
// https://docs.cronofy.com/developers/api/calendars/list-calendars/#param-calendars.provider_name
var IconForCalendarProvider = {
  apple: _iconApple.default,
  google: _iconGoogle.default,
  exchange: _iconExchange.default,
  live_connect: _iconOutlook.default,
  cronofy: _monument_symbol.default
};

// From Tom at Cronofy:
// > If you want to make requests client side, we definitely recommend using element tokens in
// > exactly the way you've described. The `Cronofy-Element` header is required, but the value is
// > only used for internal logging. We'd recommend adding a descriptive name, as it is sometimes
// > useful for identifying specific API requests when dealing with support tickets, but there's no
// > limit or requirement for what that name needs to be. Something like "Monument App, v.X.X.X"
// > would be perfect.
// Keeping these vars in case we need to make client-side requests again
// const MONUMENT_APP_VERSION = (process.env.REACT_APP_BRANCH || '').replace(/^origin\/release-/, '');
// const CRONOFY_ELEMENT_HEADER_VALUE = `Monument App, v${MONUMENT_APP_VERSION}`;

// const CRONOFY_DEFAULT_REQUEST_OPTIONS = {
//   headers: {
//     'Cronofy-Element': CRONOFY_ELEMENT_HEADER_VALUE,
//   },
//   // utils/api.js sets the default value for this to true, needs to be false for request to Cronofy
//   withCredentials: false,
// };

// @TODO: change this to monument_work_hours but should check if it'd require a data migration
exports.IconForCalendarProvider = IconForCalendarProvider;
var CRONOFY_DEFAULT_AVAILABILITY_RULE_ID = 'work_hours';
exports.CRONOFY_DEFAULT_AVAILABILITY_RULE_ID = CRONOFY_DEFAULT_AVAILABILITY_RULE_ID;
var CRONOFY_DEFAULT_AVAILABLE_PERIOD_ID_PREFIX = 'monument_work_hours';
exports.CRONOFY_DEFAULT_AVAILABLE_PERIOD_ID_PREFIX = CRONOFY_DEFAULT_AVAILABLE_PERIOD_ID_PREFIX;
var CRONOFY_DEFAULT_UNAVAILABLE_PERIOD_ID_PREFIX = 'monument_unavailable';
exports.CRONOFY_DEFAULT_UNAVAILABLE_PERIOD_ID_PREFIX = CRONOFY_DEFAULT_UNAVAILABLE_PERIOD_ID_PREFIX;
var CRONOFY_MAX_DATE_RANGE_LENGTH = 35;

// @TODO ideally we'd be more explicit with these host info values, e.g:
//
//   `${process.env.REACT_APP_HOST}${process.env.REACT_APP_PATH_PREFIX}/settings/manage-calendar`,
//
// But first we need to revisit env vars to ensure it would work as intended in all environments.
// We'd also want to revisit process.env.PUBLIC_URL (and how it's used for document.baseURI and
// Location#basename) so that pathname can be specified explicitly (window.location.pathname is
// probably OK, but ultimately it's dynamic, so who knows if there are problematic scenarios we
// just haven't thought of).
//
// For now we just derive them dynamically.
exports.CRONOFY_MAX_DATE_RANGE_LENGTH = CRONOFY_MAX_DATE_RANGE_LENGTH;
var getCronofyAuthRedirectUri = function getCronofyAuthRedirectUri() {
  return window.location.href.split('?')[0];
};
exports.getCronofyAuthRedirectUri = getCronofyAuthRedirectUri;
var getCronofyElementTokenOrigin = function getCronofyElementTokenOrigin() {
  return window.location.origin;
};
exports.getCronofyElementTokenOrigin = getCronofyElementTokenOrigin;
var hasApplicationCalendar = function hasApplicationCalendar(cronofySub) {
  return cronofySub === null || cronofySub === void 0 ? void 0 : cronofySub.startsWith('apc');
};
exports.hasApplicationCalendar = hasApplicationCalendar;